import React from "react";
import MyApplicationsPage from "../../recruitment-shared/pages/MyApplicationsPage";

export default function MyApplications() {
  return <MyApplicationsPage type="NON_FACULTY" />;
}
